class WishlistDesktop extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute("data-product-id");
    this.variantId = this.getAttribute("data-variant-id");
    this.loginText = this.querySelector(".log_in_text_desktop");
    this.wishlisted = false;
  }

  connectedCallback() {
    this.attachEventListeners();
    this.waitForCustomerId().then(() => this.checkWishlistStatus());
  }

  attachEventListeners() {
    this.addEventListener("click", this.handleWishlistToggle.bind(this));
  }

  async waitForCustomerId() {
    return new Promise((resolve) => {
      let checkInterval = setInterval(() => {
        if (typeof SWGetCustomerWishlistId === "function") {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  }

  async handleWishlistToggle() {
    if (typeof SWGetCustomerWishlistId !== "function") {
      console.error("SWGetCustomerWishlistId is missing.");
      return;
    }

    const customerId = SWGetCustomerWishlistId();

    if (!customerId || customerId === 0) {
      this.toggleLogInText();
      return;
    }

    if (this.wishlisted) {
      this.removeFromWishlist();
    } else {
      this.addToWishlist();
    }
  }

  toggleLogInText() {
    this.loginText.classList.toggle("transform-0");
  }

  addToWishlist() {
    AddToSmartWishlist(this.productId, this.variantId);
    this.wishlisted = true;
    this.updateButtonState();
    document.dispatchEvent(new Event("wishlist:updated"));
  }

  removeFromWishlist() {
    RemoveFromSmartWishlist(this.productId, this.variantId);
    this.wishlisted = false;
    this.updateButtonState();
    document.dispatchEvent(new Event("wishlist:updated"));
  }

  async checkWishlistStatus() {
    if (typeof SWGetCustomerWishlistId !== "function") {
      return;
    }

    const customerId = SWGetCustomerWishlistId();

    if (!customerId || customerId === 0) {
      this.wishlisted = false;
      this.updateButtonState();
      return;
    }

    try {
      const response = await fetch(
        `https://thebearhouse.com/a/wishlist?type=api&customerid=${customerId}&version=1`
      );
      const data = await response.json();

      if (data.items && Array.isArray(data.items)) {
        this.wishlisted = data.items.some((item) => item.id == this.productId);
      }

      this.updateButtonState();
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  }

  updateButtonState() {
    const wishlistedIcon = this.querySelector(".notWishlisted");
    const notWishlistedIcon = this.querySelector(".wishlisted");

    if (!wishlistedIcon || !notWishlistedIcon) {
      return;
    }

    if (this.wishlisted) {
      wishlistedIcon.style.display = "block";
      notWishlistedIcon.style.display = "none";
    } else {
      wishlistedIcon.style.display = "none";
      notWishlistedIcon.style.display = "block";
    }
  }
}

customElements.define("wishlist-desktop", WishlistDesktop);